import React, { useState } from 'react';

import { Actions } from '@ui/uikit/components/icons/mono';

import { Notifications } from './Notifications';

const NotificationsButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="msq-btn msq-btn-icon-md msq-btn-ghost size-[2.25rem] text-base-text-primary md-msq:msq-btn-icon-lg"
      >
        <Actions className="msq-btn-icon-child-md" />
        {/* <span className="size-2 md-msq:size-2.5 border-2 border-base-bg rounded-full bg-palette-pink-52 absolute top-0 right-0" /> */}
      </button>

      <Notifications open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

export default NotificationsButton;
